import {AdviceType, OrderAdvice} from "../../../models/OrderAdvice";
import {
    AdviceChange,
    isAdviserChange,
    isBasisToggleChange,
    isCapturedChange,
    isCommentChange,
    isDeclarationToggleChange,
    isMethodChange,
    isModelChange,
    isPlacerChange,
    isReferenceChange,
    isTakerChange,
    isTypeChange
} from "./AdviceChange";
import {ArrayUtil} from "../../../../../../../js/util/ArrayUtil";

export function applyChange(advice: OrderAdvice | null, change: AdviceChange): OrderAdvice | null {

    console.log("Applying Update", advice, change);

    // Needs to be separate to keep the smart casts happy
    if (advice == null) {
        if (isModelChange(change)) {
            return change.advice;
        } else {
            return null;
        }
    }

    if (isModelChange(change)) {
        return change.advice;
    } else if (isAdviserChange(change)) {
        return {
            ...advice,
            adviser: change.adviser
        };
    } else if (isTakerChange(change)) {
        return {
            ...advice,
            orderTaker: change.orderTaker
        };
    } else if (isPlacerChange(change)) {
        return {
            ...advice,
            orderPlacer: change.orderPlacer
        };
    } else if (isReferenceChange(change)) {
        return {
            ...advice,
            reference: change.reference
        };
    } else if (isMethodChange(change)) {
        return {
            ...advice,
            adviceMethod: change.method
        };
    } else if (isTypeChange(change)) {
        return {
            ...advice,
            adviceType: change.adviceType,
            comment: (change.adviceType === AdviceType.EXECUTION_ONLY) ? null : advice.comment,
            adviceBasis: (change.adviceType !== AdviceType.PERSONAL) ? [] : advice.adviceBasis
        };
    } else if (isCapturedChange(change)) {
        return {
            ...advice,
            adviceCaptured: change.captured.getTime()
        };
    } else if (isDeclarationToggleChange(change)) {
        return {
            ...advice,
            declarations: toggleArrayValue(advice.declarations, change.declaration)
        };
    } else if (isBasisToggleChange(change)) {
        return {
            ...advice,
            adviceBasis: toggleArrayValue(advice.adviceBasis, change.basis)
        };
    } else if (isCommentChange(change)) {
        return {
            ...advice,
            comment: change.comment
        };
    } else {
        return advice;
    }
}

function toggleArrayValue(arr: ReadonlyArray<string>, value: string): Array<string> {
    if (arr.includes(value)) {
        return arr.filter((d: string) => d !== value);
    } else {
        const clone = ArrayUtil.clone(arr);
        clone.push(value);
        return clone;
    }
}
